import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  /** Hides the label in the collapsed sidebar, keeping the rule. */
  collapsed?: boolean;
}

const AdminSectionDivider: React.FC<Props> = ({ collapsed }) => {
  const { t } = useTranslation();
  return (
    <div className="px-4 py-3 border-t border-border mt-2" data-testid="admin-section-divider">
      {!collapsed && (
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          {t('Admin Section')}
        </span>
      )}
    </div>
  );
};

export default AdminSectionDivider;
